import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'MOBILE_ERASE_STATION',
    entityName: 'MOBILE_ERASE_STATION',
});

const initialState = {
    ...crudInitialState,
    deletedControlMachine: {},
    deleting: false,
    saving: false,
    columns: []
};
const reducer = (state = initialState, action) => {
    const newState = crudReducer(state, action);
    if (newState !== null) {
        return newState;
    }
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};
export default reducer;